import { z } from 'zod';

import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#leasing

	{
		"datumLetzteRate": "YYYY-MM-DD"
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"glaeubiger": String,
		"rateMonatlich": schemaBigDecimal,
		"schlussrate": schemaBigDecimal,
	}

*/
export const schemaEuropaceLeasing = z.object({
    datumLetzteRate: z.optional(z.string().regex(regex_iso_date)),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    glaeubiger: z.optional(z.string()),
    id: z.string().min(1),
    rateMonatlich: z.optional(schemaBigDecimal),
    schlussrate: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceLeasing = z.infer<typeof schemaEuropaceLeasing>;
